import { useEffect, useRef } from 'react';

export const TrustPilot = ({ theme }: { theme?: 'light' | 'dark' }) => {
    const ref = useRef(null);

    useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
        // When it is, it will automatically load the TrustBox.
        if ((window as any).Trustpilot) {
            (window as any).Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id="5419b6ffb0d04a076446a9af"
            data-businessunit-id="5098036f00006400051e2962"
            data-style-height="40px"
            data-style-width="100%"
            data-theme={theme ? theme : 'light'}
            data-testid="trustpilot-widget"
        >
            <a
                href="https://www.trustpilot.com/review/iwoca.co.uk"
                target="_blank"
                rel="noopener noreferrer"
            >
                Trustpilot
            </a>
        </div>
    );
};
